import { AppButton } from '@clickguard/design-system'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useAccountStore } from 'store'
import { useShallow } from 'zustand/react/shallow'
import { PostHogEvent, PostHogPath } from 'utils/posthog-events'
import { RevertCancelling } from '../../../../pages/workspace/billing/subscription-tab/actions/revert-cancelling'

export const CancellationNotice = () => {
	const navigate = useNavigate()
	const { account } = useAccountStore(
		useShallow((s) => ({
			account: s.account
		}))
	)

	const subscription = account?.billing?.subscription
	const endsAt = subscription?.ends_at
	const formattedDate = endsAt ? moment(endsAt).format('MMM D, YYYY') : 'N/A'

	if (subscription?.status === 'CANCELLED') {
		return (
			<div className="flex items-center justify-between w-full">
				<span
					className="text-[18px] font-medium leading-[1.5em]"
					style={{ color: 'var(--icon-primary)' }}
				>
					Your subscription has ended. Start a new plan to restore protection
					for your workspace.
				</span>
				<div className="flex items-center ml-4 flex-shrink-0">
					<AppButton
						label="Start new plan"
						onClick={() =>
							navigate(`/settings/workspace/${account?.id}/billing`)
						}
					/>
				</div>
			</div>
		)
	}

	return (
		<div className="flex items-center justify-between w-full">
			<span
				className="text-[18px] font-medium leading-[1.5em]"
				style={{ color: 'var(--icon-primary)' }}
			>
				Subscription cancelled. You still have full access until{' '}
				<strong>{formattedDate}</strong>. Click{' '}
				<span className="font-bold" style={{ color: '#554BFD' }}>
					Resume plan
				</span>{' '}
				to keep your subscription.
			</span>
			<div className="flex items-center ml-4 flex-shrink-0">
				<RevertCancelling
					posthogEvent={PostHogEvent.RESUME_PLAN}
					posthogPath={PostHogPath.BANNER}
					buttonLabelClassName="text-base"
					posthogProperties={{
						workspace_id: account?.id,
						subscription_end_date: endsAt
							? moment(endsAt).format('YYYY-MM-DD')
							: null
					}}
				/>
			</div>
		</div>
	)
}
